export const TOGGLE_EXPANDED_DETAIL_PANEL = 'TOGGLE_EXPANDED_DETAIL_PANEL'

export function detailsPanelExpandedReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_EXPANDED_DETAIL_PANEL:
            return action.payload
        default: return state
    }
}